import { render, staticRenderFns } from "./Pagenation.vue?vue&type=template&id=1c3c10a0&scoped=true&"
import script from "./Pagenation.vue?vue&type=script&lang=ts&"
export * from "./Pagenation.vue?vue&type=script&lang=ts&"
import style0 from "./Pagenation.vue?vue&type=style&index=0&id=1c3c10a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c10a0",
  null
  
)

export default component.exports